import React from "react";

import { Button } from "@mui/material";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import { usePrompt } from "hooks";
import { useUserSelector } from "store";
import { toastify } from "utils/tyostify";

import { RoleName } from "../../../../constants";
import { SendActivityEmailContent } from "./SendActivityEmailContent";

export const SendActivityEmail: React.FC = () => {
  const openPrompt = usePrompt();
  const { email, role } = useUserSelector();
  const isAltiusAdmin = email?.endsWith("@altius.capital") && role?.name === RoleName.Admin;

  const onClick = async () => {
    const data = await openPrompt({
      Component: SendActivityEmailContent,
      componentType: "modal"
    });
    if (!data) return;
    toastify({ message: "Email queued", type: "success" });
  };

  return (
    Boolean(isAltiusAdmin) && (
      <MaterialTooltip
        title="Internal (Altius admins). Build and send a portfolio summary or capital account activity report for a chosen date range."
        placement="top"
        isShow
      >
        <Button variant="contained" color="primary" onClick={onClick}>
          Send Activity Email
        </Button>
      </MaterialTooltip>
    )
  );
};
